/* eslint-disable @typescript-eslint/no-empty-function */
import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';

@Directive({
  selector: '[lcmsPhoneMask]',
  standalone: true
})
export class PhoneMaskDirective {
  @Input() lcmsPhoneMask: string;

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    let newValue = event.target.value.replace(/\D/g, '');
    if (this.lcmsPhoneMask === 'suisse') {
      newValue = this.formatSwissPhone(newValue);
    }
    event.target.value = newValue;
  }

  formatSwissPhone(value: string): string {
    if (!value) return '';
    let formattedValue = '';
    if (value.length > 0) {
      formattedValue += value.slice(0, 2) + ' ';
    }
    if (value.length > 2) {
      formattedValue += value.slice(2, 5) + ' ';
    }
    if (value.length > 5) {
      formattedValue += value.slice(5);
    }
    return formattedValue.trim();
  }
}
